import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#f0f5ff',
      main: '#2196f3',
      dark: '#1e88e5',
      200: '#90caf9',
      800: '#1565c0',
    },
    secondary: {
      light: '#f0f5ff',
      main: '#3d52a0',
      dark: '#3d52a0',
      200: '#7091e6',
      800: '#3d52a0',
    },
    background: {
      paper: '#ffffff',
      default: '#f5f7fa', // Light gray background
    },
  },
  shape: {
    borderRadius: 8, 
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default theme;